import GradientContainer from "@app/components/gradient/gradient-container";

const EmployeesSectionHeader = () => {
  return (
    <div className="flex flex-col items-center space-y-4 w-full md:w-[440px] text-center">
      <span className="mobile-h3 md:h4 lg:h3">
        Employees and customers come first
      </span>
      <GradientContainer>
        <div className="h-2 w-36" />
      </GradientContainer>
      <span className="py-4 text-body-xl">{`No worries, we've got you covered.`}</span>
    </div>
  );
};

export default EmployeesSectionHeader;
